module.exports = __webpack_public_path__ + "img/icon_map_3_hg.8342e320.png";